export default "__VITE_ASSET__DTCQCGhe__"